import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DownloadIcon from "../svgs/download.svg";
import Tooltip from "@material-ui/core/Tooltip";
import format from "date-fns/format";
import "../report-styles/UploadFile.styles.scss";
import axios from "axios";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const DownloadSampleFile = ({ uploadConfig }) => {
  const [downloading, setDownloading] = useState(false);
  const [queryParams, setQueryParams] = useState({});

  const downloadSampleFile = () => {
    // if (varients.length && !queryParams.validation_type) {
    //   alert("Please select a validation type");
    //   return;
    // }
    var params = { ...queryParams };
    if (uploadConfig.tag) params = { ...params, tag: uploadConfig.tag };
    setDownloading(true);

    const apiUrl =
      uploadConfig.api === "/bulk-location-correction"
        ? `${process.env.REACT_APP_API_URL}/api/payment_speaker/upload${uploadConfig.api}`
        : `${process.env.REACT_APP_API_URL}/api/uploads/v1${uploadConfig.api}`;

    axios
      .get(apiUrl, {
        params: params,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
        },
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `SAMPLE_${uploadConfig.title}.xlsx`);
        document.body.appendChild(link);
        link.click();
        setDownloading(false);
      })

      .catch((err) => {
        console.log(err);
        setDownloading(false);
      });
  };
  return (
    <div>
      <Tooltip arrow title="Download sample" placement="top">
        <img
          className="upload-icon"
          src={DownloadIcon}
          alt="Download Icon"
          onClick={downloadSampleFile}
        />
      </Tooltip>
      {downloading && <ProgressLoader />}
    </div>
  );
};

const ProgressLoader = () => (
  <div className="progress" style={{ margin: 0, backgroundColor: "#362b734f" }}>
    <div className="indeterminate" style={{ backgroundColor: "#362b73" }}></div>
  </div>
);

export default DownloadSampleFile;
